import { render, staticRenderFns } from "./SimpleBookingCard.vue?vue&type=template&id=db2251b4&scoped=true"
import script from "./SimpleBookingCard.vue?vue&type=script&lang=js"
export * from "./SimpleBookingCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db2251b4",
  null
  
)

export default component.exports